import axios from 'axios';
import queryString from 'query-string';
import actions from '../actions/performance';

export default {
	namespaced: true,
	state: {
		entities: [],
		links: [],
		paginationMetadata: {},
	},
	mutations: {
		[actions.SET_DATA]: (state, data) => {
			state.links = data.links;
			state.entities = data.entities;
			state.paginationMetadata = data.paginationMetadata;
		},
		[actions.SET_LINK]: (state, data) => {
			state.links = data.links;
		},
		[actions.REMOVE_DATA]: (state) => {
			state.links = [];
			state.entities = [];
			state.paginationMetadata = {};
		},
		[actions.REMOVE_GRID_DATA]: (state) => {
			state.entities = [];
			state.paginationMetadata = {};
		},
	},
	actions: {
		[actions.GET_PERFORMANCE_LINKS]: async ({ commit, rootState }) => {
			try {
				commit(actions.REMOVE_DATA);
				const link = rootState.root.links.find(x => x.rel === 'perf_links' && x.templated);

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_LINK, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_PERFORMANCE_LIST_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'perf_list_links' && x.templated);

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_LINK, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_PERFORMANCE]: async (
			{ commit, rootState },
			{ masterOrgId, queryParameters, currentOrgId }) => {
			try {
				commit(actions.REMOVE_DATA);

				const link = rootState.root.links.find(x => x.rel === 'perf' && x.templated);

				const queryTemplatePos = link.href.indexOf('{?');
				const queryTemplate = link.href
					.substring(queryTemplatePos, link.href.length);

				const href = link.href
					.replace('{masterOrgId}', masterOrgId)
					.replace('{currentOrgId}', currentOrgId)
					.replace(queryTemplate, `?${queryString.stringify(queryParameters)}`);

				const response = await axios.get(href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_FILTERED_PERFORMANCE]: async (
			{ commit, rootState },
			{ queryParameters }) => {
			try {
				commit(actions.REMOVE_DATA);

				const link = rootState.root.links.find(x => x.rel === 'filtered_perf' && x.templated);

				const queryTemplatePos = link.href.indexOf('{?');
				const queryTemplate = link.href
					.substring(queryTemplatePos, link.href.length);

				const href = link.href
					.replace(queryTemplate, `?${queryString.stringify(queryParameters)}`);

				const response = await axios.get(href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.FETCH_PERFORMANCE]: async ({ commit }, link) => {
			try {
				commit(actions.REMOVE_DATA);

				const response = await axios.get(link.href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_CREATED_PERFORMANCES]: async ({ commit, rootState }, perfRequest) => {
			try {
				commit(actions.REMOVE_DATA);

				const link = rootState.root.links.find(x => x.rel === 'perf_created' && x.templated);

				const href = link.href
					.replace('{masterOrgId}', perfRequest.masterOrgId)
					.replace('{competitionId}', perfRequest.competitionId)
					.replace('{eventId}', perfRequest.eventId)
					.replace('{classId}', perfRequest.classId);

				const response = await axios.get(href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.FETCH_CLASSES]: async ({ rootState }, performanceListOrOrgGuid) => {
			let classes = [];

			try {
				const link = rootState.root.links.find(x => x.rel === 'classes_for_selector');

				const href = link.href
				.replace('{performanceListOrOrgGuid}', performanceListOrOrgGuid)

				const response = await axios.get(href);

				const { data } = response;

				classes = data;
			} catch (error) {
				throw error;
			}

			return classes;
		},
		[actions.FETCH_EVENT_CLASS]: async ({ rootState }, eventClassRequest) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'event_class' && x.templated);

				const href = link.href
					.replace('{eventCode}', eventClassRequest.eventCode)
					.replace('{classCode}', eventClassRequest.classCode);

				const response = await axios.get(href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.FETCH_EVENTS]: async ({ rootState }, performanceListOrOrgGuid) => {
			let events = [];

			try {
				const link = rootState.root.links.find(x => x.rel === 'events_for_selector');

				const href = link.href
				.replace('{performanceListOrOrgGuid}', performanceListOrOrgGuid)

				const response = await axios.get(href);

				const { data } = response;

				events = data;
			} catch (error) {
				throw error;
			}

			return events;
		},
		[actions.FETCH_CREATE_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'createrlink');

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_LINK, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.FETCH_GLOBAL_COMPETITORS]: async ({ rootState }, {performanceListOrOrgGuid, query}) => {
			let competitors = [];

			try {
				const link = rootState.root.links.find(x => x.rel === 'global_competitors');

				const href = link.href.replace('{query}', query).replace('{performanceListOrOrgGuid}', performanceListOrOrgGuid);

				const response = await axios.get(href);

				const { data } = response;

				competitors = data;
			} catch (error) {
				throw error;
			}

			return competitors;
		},
		[actions.GET_PERFORMANCE_FOR_SELECTOR]: async ({ rootState }, organizationId) => {
			let performances = [];

			try {
				const link = rootState.root.links
					.find(x => x.rel === 'perf_for_selectors' && x.templated);

				const href = link.href
					.replace('{masterOrgId}', organizationId);

				const response = await axios.get(href);

				const { data } = response;

				performances = data;
			} catch (error) {
				throw error;
			}

			return performances;
		},
		[actions.GET_CLASS_BY_PERF_ID]: async (context, { href }) => {
			try {
				const resp = await axios.get(href);
				const { data } = resp;
				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_SUBEVENTS_FOR_MULTI]: async ({ rootState }, { eId, cId }) => {
			try {
				const link = rootState.root.links
					.find(x => x.rel === 'subevents_for_multi' && x.templated);

				const href = link.href
					.replace('{eId}', eId)
					.replace('{cId}', cId);
				const resp = await axios.get(href);
				const { data } = resp;
				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_EVENT_BY_PERF_ID]: async (context, { href }) => {
			try {
				const resp = await axios.get(href);
				const { data } = resp;
				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.CREATE_NEW_PERFORMANCE]: async (context, { newPerf, link }) => {
			try {
				await axios.post(link.href, newPerf);
			} catch (error) {
				throw error;
			}
		},
		[actions.UPDATE_PERF]: async (context, { newPerf, link }) => {
			try {
				await axios.put(link.href, newPerf);
			} catch (error) {
				throw error;
			}
		},
		[actions.DELETE_PERF]: async (context, { href }) => {
			try {
				await axios.delete(href);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_PERFORMANCE_BY_ID]: async ({ rootState }, id) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'perf_by_id' && x.templated);

				const href = link.href
					.replace('{id}', id);

				const response = await axios.get(href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
	},
	getters: {
		Entities: state => state.entities,
		Links: state => state.links,
		Pagination: state => state.paginationMetadata,
	},
};
